import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { WorkflowInstanceSummary } from '@flowx/designer/modules/integration-designer/models/workflow-instance.entity'
import { WorkflowRunTriggerType } from '@flowx/designer/modules/integration-designer/models/workflow.entity'
import {
  WorkflowApiService,
  WorkflowInstancesQueryParams,
} from '@flowx/designer/modules/integration-designer/services/workflow.api'
import { PaginationQueryParams } from '@flowx/designer/shared/api/api-http.service'
import {
  Application,
  BuildManifestResourceSummary,
} from '@flowx/designer/shared/entities/application.entity'
import { toRuntimeListFilterParams } from '@flowx/designer/shared/entities/utils'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PaginatedEndpoint,
  PaginatedResponse,
} from '@flowx/designer/shared/services/paginated-datasource'
import { UrlParametersStoreService } from '@flowx/designer/shared/services/url-parameters-store.service'

@Injectable({ providedIn: 'root' })
export class WorkflowInstanceService extends GridSearchService<WorkflowInstanceSummary> {
  #workflowApiService = inject(WorkflowApiService)
  #urlParametersStore = inject(UrlParametersStoreService)

  getNames(includeDependencies?: boolean): Observable<BuildManifestResourceSummary[]> {
    const { appId } = this.#urlParametersStore.urlParameters
    return this.#workflowApiService.getNames(appId, includeDependencies)
  }

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<any, WorkflowInstanceSummary>
    sort: { property: string; direction: 'asc' | 'desc' }
    query: Partial<any>
  } {
    return {
      endpoint: this.#getWorkflowInstances.bind(this),
      sort: null,
      query: {},
    }
  }

  #getWorkflowInstances(
    paginationParams: PaginationQueryParams,
    params: WorkflowInstancesQueryParams & {
      appId: Application['appId']
      /** ag-grid keys the filter model by column, so the Origin filter arrives singular. */
      workflowRunTriggerType?: WorkflowRunTriggerType[]
    }
  ): Observable<PaginatedResponse<WorkflowInstanceSummary>> {
    const { appId, workflowRunTriggerType, ...queryParams } = params

    return this.#workflowApiService.getWorkflowInstances(
      appId,
      {
        ...toRuntimeListFilterParams(queryParams, 'status', 'statuses'),
        ...(workflowRunTriggerType?.length && {
          workflowRunTriggerTypes: workflowRunTriggerType,
        }),
      },
      paginationParams
    )
  }
}
